/* eslint-disable react/no-array-index-key */
import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import t from 'react-translate';
import { css } from '@emotion/react';
import { useSelector } from 'react-redux';
import { CourseAliases } from 'redux/schemas/models/course';
import { getCourseAliases, getCurrentCourseActiveAICreationCommand } from 'redux/selectors/course';
import NvModal, { ModalType } from 'shared/components/nv-modal';
import { halfSpacing, largeSpacing, standardSpacing, tripleSpacing } from 'styles/global_defaults/scaffolding';
import { useAppDispatch } from 'redux/store';
import { markAICourseSummaryModalAsSeen } from 'redux/actions/ai-course-creation';
import { screenSmMax } from 'styles/global_defaults/media-queries';
import { config } from '../../../../config/config.json';

const CourseSummary = ({ showCourseSummaryModal, handleCourseSummaryModal }) => {
  const modalStyles = css`
    .bs4-modal-dialog {
      @media (max-width: ${screenSmMax}px) {
        padding-top: ${tripleSpacing}px !important;
      }
      .bs4-modal-content {
        height: auto !important;
      }

      .bs4-modal-body {
        padding: ${tripleSpacing}px !important;
        padding-top : ${largeSpacing}px !important;
      }
    }
    .ok-btn {
      padding: ${halfSpacing}px ${standardSpacing}px ;
      font-size: 16px;
      line-height: 25px;
      border: 0px
    }
    .good-news {
      background: -webkit-linear-gradient(48.41deg, #60F3AB 0%, #00CCBC 45%, #009AC0 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .dynamic-data {
      overflow-y:auto;
      max-height: 220px;
    }

  `;

  const dispatch = useAppDispatch();
  const aliases: CourseAliases = useSelector((state) => getCourseAliases(state));
  const currentAICreationCommand = useSelector(getCurrentCourseActiveAICreationCommand);
  const catalogId = useSelector((state) => state.app.currentCatalogId);


  useEffect(() => {
    if (showCourseSummaryModal && currentAICreationCommand?.id) {
      dispatch(markAICourseSummaryModalAsSeen({
        catalogId,
        aiCreationCommandId: currentAICreationCommand.id,
      }));
    }
  }, [catalogId, currentAICreationCommand?.id, currentAICreationCommand?.inProgress, dispatch, showCourseSummaryModal]);

  const summaryText = currentAICreationCommand?.summary || '';
  const bulletPoints = summaryText.split(' - ').map((point, index) => (index === 0 ? point.replace(/^-\s*/, '').trim() : point.trim())).filter(point => point !== '');
  // Convert to proper HTML list format
  const formattedSummary = `<ul><li>${bulletPoints.join('</li><li>')}</li></ul>`;

  return (
    <div>
      <NvModal
        width={600}
        show={showCourseSummaryModal}
        onClose={handleCourseSummaryModal}
        closeDataQa={config.pendo.novoAiCourseCreation.icons.closeIcon}
        type={ModalType.DYNAMIC}
        modalStyles={modalStyles}
        header={t.LECTURE_PAGES.LHS.NOVO_AI.SUCCESS_MODEL.COURSE_SUMMARY(aliases.courseAliases)}
        body={(
          <div className='sucesspopup'>
            <div>
              <div className='good-news-text page-title font-weight-bolder text-align-center mb-2'>
                {t.LECTURE_PAGES.LHS.NOVO_AI.SUCCESS_MODEL.PARTY_EMOJI()}
                <span className='good-news'>{t.LECTURE_PAGES.LHS.NOVO_AI.SUCCESS_MODEL.GOOD_NEWS()}</span>
                {t.LECTURE_PAGES.LHS.NOVO_AI.SUCCESS_MODEL.PARTY_EMOJI()}
              </div>
              <div className='quick-summary text-large-regular r font-weight-bolder text-align-center'>
                {t.LECTURE_PAGES.LHS.NOVO_AI.SUCCESS_MODEL.QUICK_SUMMARY(aliases.courseAliases)}
              </div>
              <hr className='underline text-gray-4 my-5' />
              <div className='mb-3 text-large-body'>{t.LECTURE_PAGES.LHS.NOVO_AI.SUCCESS_MODEL.COURSE_TOPIC_TITLE(aliases.courseAliases)}</div>
              <div className='dynamic-data text-large-body'>
                <div dangerouslySetInnerHTML={{ __html: formattedSummary }} />
              </div>
              <div className='text-align-center mt-6'>
                <Button className='ok-btn' onClick={handleCourseSummaryModal} data-qa={config.pendo.novoAiCourseCreation.buttons.okButton}>
                  {t.SHARED.OK()}
                </Button>
              </div>
            </div>
          </div>
        )}
      />
    </div>

  );
};

export default CourseSummary;
